
















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { InsuranceCard, Car } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import LanguageControl from "_P/LanguageControl";
import { CarDocumentType } from "@/models/Models";
@Component
export default class CarSignYear extends Vue {
    @Prop() card: InsuranceCard;
    @Prop() car: Car;
    Rules = ValidationRules;
    LanguageControls = LanguageControl;
    CarDocumentTypes = CarDocumentType;

    @Watch("car.withOutGosSign")
    withOutGosSignChanged(val) {
        this.$store.direct.commit.insurance.setWithoutGosSign(val);
        this.$store.direct.commit.insurance.setAutocodeDocumentCar(this.car);
    }

    created() {
        this.$set(this.car, "withOutGosSign", !this.car.licensePlate);
    }

    get kostylPlaceholder() {
        let gosSign: string = JSON.parse(JSON.stringify(this.car.licensePlate));
        if (!gosSign?.length ?? true) return "А000АА00";
        const value = gosSign;
        const charsLeft = "А000AA00".slice(gosSign.length, 8);
        return value + charsLeft;
    }

    isGosSignChar(v) {
        // ♿ да простит бог костыляния меня за такой подробный код
        if (!v) return true;
        const gosChar = /[АВЕКМНОРСТУХFDTRVYJHCNE]/i;
        const gosDigit = /\d/;

        const region = v.slice(6, 9);
        const lastChars = v.slice(4, 6);
        const digits = v.slice(1, 4);
        const firstChar = v.slice(0, 1);
        const regionOk = !region || gosDigit.test(region);
        const lastCharsOk = !lastChars || gosChar.test(lastChars);
        const digitsOk = !digits || gosDigit.test(digits);
        const firstCharOk = !firstChar || gosChar.test(firstChar);
        return (firstCharOk && digitsOk && lastCharsOk && regionOk) || "Ошибка";
    }
}
